import { createNoopMeter } from '@opentelemetry/api';
import { MeterProvider } from '@opentelemetry/sdk-metrics';

class NoopMeterProvider extends MeterProvider {
  constructor(options = {}) {
    var _options$getMeter;
    super(options);
    this.internalGetMeter = void 0;
    this.internalGetMeter = (_options$getMeter = options.getMeter) !== null && _options$getMeter !== void 0 ? _options$getMeter : createNoopMeter;
  }
  getMeter(name, _version, _options) {
    return this.internalGetMeter(name);
  }
  addMetricReader(_metricReader) {}
  shutdown(_options) {
    return Promise.resolve();
  }
  forceFlush(_options) {
    return Promise.resolve();
  }
}

export { NoopMeterProvider };
